const TESTIMONY_ENDPOINTS = {
  TESTIMONY: "/frontend/testimony/list",
 
};

export default TESTIMONY_ENDPOINTS;